import { Modal } from "./base_modal";
import { renderList } from "./utils";
import { STATUS_OPTIONS } from "../datatable/free_phones/phone_statuses.config";

/** Модальное окно массового изменения статуса */
export class BulkStatusModal extends Modal {
  constructor(selectedCount) {
    super({ className: "bulk-status-modal" });

    this.selectedCount = selectedCount;
  }

  /** Строит содержимое модального окна
   * @returns {string} HTML-строка с содержимым модального окна
   */
  buildContent() {
    return `
      <h3>Изменить статус для ${this.selectedCount} номеров</h3>
      <div class="status-options">
        ${renderList(
          STATUS_OPTIONS,
          option => `
            <button class="status-option" data-status="${option.value}">
              ${option.label}
            </button>
          `
        )}
      </div>
      <div class="modal-actions">
        <button class="btn-cancel">Отмена</button>
      </div>
    `;
  }

  /** Настраивает обработчики */
  setupHandlers({ modal, close }) {
    modal.querySelector(".btn-cancel")?.addEventListener("click", () => close(null));

    modal.querySelectorAll(".status-option").forEach(button => {
      button.addEventListener("click", () => {
        close(button.dataset.status);
      });
    });
  }

  /** Открывает модальное окно */
  async show() {
    return this.open({
      content: this.buildContent(),
      onInit: ({ modal, close }) => this.setupHandlers({ modal, close }),
    });
  }
}
